import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@/utils/cn';

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

/**
 * Toggle switch component
 */
export function Switch({
  checked,
  onCheckedChange,
  label,
  disabled = false,
}: SwitchProps) {
  return (
    <div className="flex items-center gap-3">
      <SwitchPrimitive.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className={cn(
          'w-11 h-6 rounded-full transition-colors relative flex items-center',
          'data-[state=checked]:bg-monta-blue data-[state=unchecked]:bg-ink/20',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface'
        )}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            'block w-5 h-5 bg-white rounded-full shadow-sm transition-transform',
            'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0.5'
          )}
        />
      </SwitchPrimitive.Root>
      {label && (
        <span className="text-sm text-ink/80 select-none">{label}</span>
      )}
    </div>
  );
}
